/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QuestionnaireQuestionResponse } from './questionnaire-question-response';
import { QuestionnairePage } from './questionnaire-page';
import { QuestionnaireType } from './questionnaire-type';
import { TestStatusEnum } from './test-status-enum';

export interface QuestionnaireResponse {
  readonly id: string;
  readonly questionnaire_type: QuestionnaireType;
  readonly test_status: TestStatusEnum;
  readonly questions: Array<QuestionnaireQuestionResponse>;
  readonly pages: Array<QuestionnairePage>;
}
export namespace QuestionnaireResponse {}
